export default {
  errors: {
    common: 'Terjadi Kesalahan',
    notFound: 'Tidak Ditemukan',
    noInternet: 'Tidak ada koneksi internet',
    emailNotRegistered: 'Email belum terdaftar, silahkan hubungi admin',
    emailAlreadyUsed: 'Email sudah digunakan, silahkan gunakan yang lain',
    noAccess: 'Anda tidak punya akses untuk membuka halaman ini',
  },
  validation: {
    email: 'Format email yang digunakan salah',
    password: 'Silahkan masukkan password anda',
    passwordAgain: 'Silahkan masukkan kembali kata sandi anda',
    passwordNotMatch: 'Kata sandi tidak cocok!',
    passwordMustSix: 'Panjang kata sandi harus minimal 6 karakter',
    username: 'Silahkan masukkan nama Anda',
    isRequired: (field) => `${field} wajib diisi`
  }
}
